var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"banner-logo"}},[_c('img',{staticClass:"logo",attrs:{"src":require("@imagesBrand/logo.svg"),"alt":_vm.brandName}})])}
var staticRenderFns = []

export { render, staticRenderFns }